// extracted by mini-css-extract-plugin
export var aggregationCell = "_2m-p";
export var aggregationRow = "_2m-o";
export var borderlessSpinnerContainer = "_2m-3";
export var cardLayout = "_2m-6";
export var cardLayoutNoFooter = "_2m-a";
export var cardLayoutPageControl = "_2m-9";
export var cardLayoutWithFooter = "_2m-8";
export var closeIcon = "_2m-h";
export var columnHeaderSurface = "_2m-d";
export var columnHeaderSurfaceDragOverlay = "_2m-x";
export var columnHeaderSurfaceResizing = "_2m-u";
export var contextMenuAnchor = "_2m-1";
export var draggableColumnHeader = "_2m-v";
export var draggableColumnHeaderOverlay = "_2m-w";
export var expandIcon = "_2m-i";
export var expanded = "_2m-j";
export var filterDropdown = "_2m-k";
export var filterDropdownDivider = "_2m-f";
export var filterDropdownHeader = "_2m-n";
export var filterDropdownItem = "_2m-m";
export var filterDropdownModal = "_2m-l _2m-k";
export var filterItem = "_2m-e";
export var normalCellWithAdjustableBorder = "_2m-g";
export var pinButtonContainer = "_2m-q";
export var pinIcon = "_2m-r";
export var pinIconActive = "_2m-s";
export var spinner = "_2m-0";
export var spinnerContainer = "_2m-2";
export var tableContainer = "_2m-4";
export var tableContentDraggingColumns = "_2m-c";
export var tableContentInner = "_2m-7";
export var tableContentInnerFill = "_2m-b";
export var tableContentWrapper = "_2m-5";
export var viewButtonContainer = "_2m-t";